import React, { useState, useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { getCommercialCategoryShortName } from "data/categories";

// exclude catalogs items from filter box. Force user to remove it only by local offer block
const CATALOG_ITEM = "catalogs.slug";

export default function ClearFiltersBox({ items, refine }) {
  const classes = useStyle();
  const [filters, setFilters] = useState(items?.filter((item) => item.id !== CATALOG_ITEM));
  const priceItem = filters?.find((item) => item.id === "price");
  const dimensions = filters?.filter((item) => ["width", "height", "depth"].includes(item.id));
  const capacities = filters?.filter(
    (item) => item.id.includes("Capacité") || item.id.includes("Niveau") || item.id.includes("Puissance")
  );

  useEffect(() => {
    setFilters(items?.filter((item) => item.id !== CATALOG_ITEM));
  }, [items]);

  const shouldDisplay =
    (priceItem && priceItem.currentRefinement?.max) ||
    (dimensions && dimensions.length) ||
    (capacities && capacities.length) ||
    filters?.find((item) => item.items);

  const getDimensionName = (id) => {
    switch (id) {
      case "width":
        return "Largeur";
      case "height":
        return "Hauteur";
      case "depth":
        return "Profondeur";
      default:
        return undefined;
    }
  };

  const getLabel = (min, max, name, dimension) => {
    return (
      <>
        {name}:
        {!max
          ? ` Supérieur à ${min}${dimension}`
          : !min
          ? ` Inférieur à ${max}${dimension}`
          : ` ${min}${dimension} - ${max}${dimension}`}
      </>
    );
  };

  return shouldDisplay ? (
    <Box display={"flex"} alignItems={"baseline"} mb={2} ml={7} whiteSpace={"nowrap"}>
      <Box pr={3}>
        <Typography>Filtres actifs:</Typography>
      </Box>
      <Box display={"flex"} flexWrap={"wrap"}>
        {priceItem && priceItem.currentRefinement?.max && (
          <Box
            key={priceItem.label}
            onClick={(event) => {
              event.preventDefault();
              refine(priceItem.value);
            }}
            className={classes.filterItem}
          >
            {getLabel(priceItem.currentRefinement.min, priceItem.currentRefinement.max, "Prix", "€")}
            <CloseIcon className={classes.closeIcon} />
          </Box>
        )}
        {dimensions &&
          dimensions.map((dimensionItem) => (
            <Box
              key={dimensionItem.label}
              onClick={(event) => {
                event.preventDefault();
                refine(dimensionItem.value);
              }}
              className={classes.filterItem}
            >
              {getLabel(
                dimensionItem.currentRefinement.min,
                dimensionItem.currentRefinement.max,
                getDimensionName(dimensionItem.id),
                "cm"
              )}
              <CloseIcon className={classes.closeIcon} />
            </Box>
          ))}
        {capacities &&
          capacities.map((capacity) => (
            <Box
              key={capacity.label}
              onClick={(event) => {
                event.preventDefault();
                refine(capacity.value);
              }}
              className={classes.filterItem}
            >
              {getLabel(
                capacity.currentRefinement.min,
                capacity.currentRefinement.max,
                capacity.attribute.split(".")[capacity.attribute.split(".").length - 1],
                ""
              )}
              <CloseIcon className={classes.closeIcon} />
            </Box>
          ))}
        {filters.map((item) => (
          <Box key={item.label}>
            {item.items && (
              <Box display={"flex"}>
                {item.items.map((nested) => (
                  <Box
                    key={nested.label}
                    onClick={(event) => {
                      event.preventDefault();
                      refine(nested.value);
                    }}
                    className={classes.filterItem}
                  >
                    {item.attribute === "appearance" ? getCommercialCategoryShortName(nested) : nested.label}
                    <CloseIcon className={classes.closeIcon} />
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
        <Button
          className={classes.clearButton}
          color="secondary"
          onClick={(event) => {
            event.preventDefault();
            refine(items.filter((item) => item.id !== CATALOG_ITEM));
          }}
        >
          Tout réinitialiser
        </Button>
      </Box>
    </Box>
  ) : null;
}

const useStyle = makeStyles((theme) => ({
  clearButton: {
    textDecoration: "underline",
  },
  filterItem: {
    display: "flex",
    fontWeight: "500",
    color: theme.palette.secondary.main,
    fontSize: 16,
    background: "#F2F2F2",
    borderRadius: 32,
    alignItems: "center",
    cursor: "pointer",
    padding: "8px 16px",
    marginRight: 16,
    marginBottom: 4,
    height: 40,
  },
  closeIcon: {
    width: 12,
    marginLeft: 8,
  },
}));
